import React from 'react';

const WhyAttend = () => {
  return (
    <section className="why-attend">
      <div className="container">
        <h2 className="section-title">Build Practical AI Confidence, Not Just Awareness</h2>
        <div className="why-content">
          <p className="intro-text">AI is already reshaping how HR operates. But most leaders still struggle to turn the hype into tangible results.</p>
          
          <div className="benefits">
            <p className="benefits-intro">In this 90-minute session, you'll discover:</p>
            <ul className="benefits-list">
              <li>How large language models (like ChatGPT, Claude, and Gemini) actually work, and what every HR professional should know.</li>
              <li>How to write prompts that get reliable, high-quality results.</li>
              <li>Real use cases that save hours every week, from creating interview kits to converting policies into employee-friendly communication.</li>
              <li>The top tools every HR leader should know in 2025.</li>
            </ul>
            <p className="outcome">By the end, you'll know exactly where to start using AI in your work, safely and effectively.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyAttend;
